import { compose, join, slice, split } from "ramda";

const extractMultipartBody = compose(
    join('\r\n'),
    slice(4, -1),
    split('\r\n'),
);

export const parseMultipart = (response, boundary) => {
    const separator = '--' + boundary;
    const parts = response.split(separator);
    const validParts = parts.slice(1, -1);

    return validParts.map(extractMultipartBody);
};

export const getBoundary = (contentType) => contentType.split('; boundary=')[1];